import HallOverViewSubPage from "./hall-overview-sub-page";
import HallStandsSubPage from "./hall-stands-sub-page";

const HallSubPage = {
    OverView: HallOverViewSubPage,
    Stands: HallStandsSubPage
};

export default HallSubPage;